/**
 * Throw from a `default:` branch to assert a switch is exhaustive.
 *
 * Passing the discriminant makes the check a compile-time one: if a new member
 * is added to the union the argument is no longer `never` and this stops
 * building, rather than silently falling through at runtime.
 */
export class UnreachableCaseError extends Error {
  constructor(value?: never) {
    super(value === undefined ? "Unreachable case" : `Unreachable case: ${JSON.stringify(value)}`);
    this.name = "UnreachableCaseError";
  }
}
